/**
 * @voltxampere/ui — MPU6050 6-axis IMU variant (Sprint 48-8, placeholder)
 *
 * Sprint 48-8 — New 6-axis Inertial Measurement Unit (3-axis gyroscope
 * + 3-axis accelerometer). I2C 7-bit slave 0x68 (default; AD0 pin
 * pull-up → 0x69). Built-in DMP (Digital Motion Processor) for
 * sensor fusion. Used in drones, robotics, gaming, fitness trackers.
 *
 * Sensor activation layer reads:
 *   - 0x75 WHO_AM_I → constant 0x68
 *   - 0x3B..0x40 ACCEL_XOUT_H..ACCEL_ZOUT_L (6 bytes)
 *   - 0x41..0x42 TEMP_OUT_H..L
 *   - 0x43..0x48 GYRO_XOUT_H..GYRO_ZOUT_L
 *
 * PLACEHOLDER — full DMP simulation Sprint 50+.
 *
 * Reference: InvenSense MPU-6000/6050 RM-MPU-6000A-00 (rev 4.2, 2013).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const sensorMpu6050 = {
    id: "mpu6050",
    nameTr: "MPU6050 (6-axis IMU, I2C, placeholder)",
    nameEn: "MPU6050 (6-axis IMU, I2C, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "U",
    defaultValue: "MPU6050",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 3.3,
        i2cAddress: 0x68,
        i2cFrequency: 400_000,
        whoAmIRegister: 0x75,
        whoAmIValue: 0x68,
        accelStartRegister: 0x3b,
        gyroStartRegister: 0x43,
        accelRangeG: 2,
        gyroRangeDps: 250,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=sensor-mpu6050.js.map